export default "__VITE_ASSET__Cwvq1KxT__"